module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "section-container"
  }, [_c('div', {
    staticClass: "main-container clearfix"
  }, [_c('div', {
    ref: "sidebar",
    staticClass: "side pull-left",
    style: ({
      top: _vm.sideTop + 'px'
    })
  }, [_c('div', {
    staticClass: "side-user"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "info pull-left"
  }, [_c('p', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.info.status === 0),
      expression: "info.status===0"
    }],
    staticClass: "name",
    staticStyle: {
      "cursor": "pointer"
    },
    on: {
      "click": function($event) {
        _vm.$router.push('/authentication')
      }
    }
  }, [_vm._v("未实名，去认证")]), _vm._v(" "), _c('p', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.info.status === 1),
      expression: "info.status===1"
    }],
    staticClass: "name"
  }, [_vm._v("已认证，" + _vm._s(_vm.info.name))]), _vm._v(" "), _c('p', {
    staticClass: "phone"
  }, [_vm._v(_vm._s(_vm.info.phone))]), _vm._v(" "), _c('p', {
    staticClass: "side-bottom"
  }, [_c('span', {
    staticClass: "time"
  }, [_vm._v("注册时间")]), _vm._v(_vm._s(_vm.info.registerTime))])])]), _vm._v(" "), _c('div', {
    staticClass: "side-content"
  })]), _vm._v(" "), _c('div', {
    staticClass: "content pull-right"
  }, [_c('router-view')], 1)])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "avatar pull-left"
  }, [_c('img', {
    attrs: {
      "src": "/static/img/avatar.jpg",
      "alt": "用户头像"
    }
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?{"id":"data-v-ef451166"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/user/order.vue
// module id = 629
// module chunks = 1